module.exports = __webpack_public_path__ + "static/media/laptop-care-whitelabel.76489c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/binokular/laptop-care-whitelabel.png
// module id = 832
// module chunks = 0